import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';

import {clearTagsInSearchParams} from 'shared/lib/filterHelper';

const useClearTagsFilter = (): () => void => {
    const [searchParams, setSearchParams] = useSearchParams();

    return useCallback(() => {
        setSearchParams(clearTagsInSearchParams(searchParams));
    }, [searchParams, setSearchParams]);
};

export default useClearTagsFilter;
